/*
 * Video die pas laadt als hij in beeld komt
 * -----------------------------------------------------------------------------
 * De sfeervideo op de productpagina is groot. Zonder maatregelen haalt elke
 * bezoeker hem binnen, ook wie nooit tot dat blok scrolt.
 *
 * Wat er gebeurt:
 *  - de <video> staat zonder bron in de pagina, met preload="none" en een
 *    poster. De browser haalt dan alleen die ene afbeelding op;
 *  - pas als het blok tot 400px van het scherm is genaderd wordt de bron gezet
 *    en begint het laden. Die marge geeft het bestand een voorsprong, zodat hij
 *    meestal al draait op het moment dat je hem ziet;
 *  - is de video eenmaal geladen, dan speelt hij alleen terwijl hij in beeld is.
 *    Uit beeld pauzeert hij: dat scheelt de bezoeker rekenwerk en batterij.
 *
 * Wie "verminder beweging" aan heeft staan krijgt geen video maar de poster.
 * Dat is niet alleen netjes, het scheelt die bezoeker ook de hele download.
 */

(function () {
  'use strict';

  const ROOT_MARGIN = '400px 0px';

  function preferReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  /* Zet de bronnen en start het laden. Gebeurt precies één keer per video. */
  function load(video) {
    if (video.dataset.loaded) return;
    video.dataset.loaded = 'true';

    Array.from(video.querySelectorAll('source[data-src]')).forEach((source) => {
      source.src = source.dataset.src;
      source.removeAttribute('data-src');
    });

    video.load();
  }

  function play(video) {
    // play() geeft een promise die afketst als de browser het weigert. Zonder
    // catch levert dat een onafgevangen fout op in de console.
    const started = video.play();
    if (started && typeof started.catch === 'function') started.catch(() => {});
  }

  function watch(video) {
    if (typeof IntersectionObserver !== 'function') {
      // Geen observer: dan maar meteen laden, dat is nog altijd beter dan niets.
      load(video);
      return;
    }

    // Ruime marge: laden begint voordat het blok in beeld is.
    const loader = new IntersectionObserver(
      (entries, self) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          load(video);
          self.disconnect();
        });
      },
      { rootMargin: ROOT_MARGIN }
    );
    loader.observe(video);

    // Krappe marge: spelen alleen terwijl hij echt zichtbaar is.
    const player = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            play(video);
          } else {
            video.pause();
          }
        });
      },
      { threshold: 0.25 }
    );
    player.observe(video);
  }

  function init() {
    document.querySelectorAll('video[data-lazy-video]').forEach((video) => {
      if (preferReducedMotion()) {
        // De poster staat er al; de bron laten we ongemoeid, dus er wordt
        // niets gedownload. Wel de bediening tonen zodat het nog te starten is.
        video.setAttribute('controls', '');
        video.removeAttribute('autoplay');
        return;
      }
      watch(video);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
